import { DeskData } from '@/datamodel/deskdata'
import { GameResult } from '@/datamodel/game-result'
import { TableLimit } from '@/datamodel/types'
import { EventBuss, RESULT } from '@/utils/constants'
import { BetForm, MemberLimit } from 'vue'
import { Options, Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'

@Options({})
export class BetViewBaseMixin extends Vue {
    //#region Vuex

    @Getter('betCoin') betCoin!: number
    // @Getter('deskLimit') tableLimit!: MemberLimit
    @Getter('token') sid!: string
    @Getter('userId') uid!: string

    // @Getter('deskLimit') deskLimit!: TableLimit

    @Action('showLoading') showLoading!: () => void
    @Action('hideLoading') hideLoading!: () => void
    @Action('setBetCoin') setBetCoin!: (coin: number) => void

    //#endregion
    @Prop({ default: -1 }) chipValue!: number
    @Prop({ default: false }) allowBet!: boolean

    @Prop({ default: 0 }) redConfirmed!: number
    @Prop({ default: 0 }) blueConfrimed!: number
    @Prop({ default: 0 }) greenConfrimed!: number
    @Prop({ default: -1 }) deskId!: number

    emitter!: Vue['emitter']

    selectedBetArea = -1

    redTemp = 0
    blueTemp = 0
    greenTemp = 0

    hasPendingRequest = false

    isGreen = false
    isRed = false
    isBlue = false

    OnCancelBetTemp(): void {
        //
    }

    ResetConfirmedTemp(): void {
        //
    }

    showResult(deskResult: GameResult | undefined): void {
        if (deskResult) {
            console.log('show Game Result here')
            const { whoWin } = deskResult
            this.isRed = whoWin === RESULT.DRAGON
            this.isBlue = whoWin === RESULT.TIGER
            this.isGreen = whoWin === RESULT.DRAGON_TIGER_TIE
        }
    }

    hideGameResult(): void {
        this.isRed = false
        this.isGreen = false
        this.isBlue = false
    }

    onBetSuccess(obj: {
        betFormList: any[]
        id: number
        amount: number
    }): void {
        if (obj.betFormList && obj.betFormList.length > 0) {
            this.emitter.emit(EventBuss.BET_SUCCESS, obj)
        }

        // this.$emit('on-bet-success', betFormList, tableId)
    }
}
